export default [
  {
    name: 'ontologygas',
    displayName: 'Ontology Gas',
    ticker: 'ONG',
    units: { uONG: 0, ONG: 9 },
    info: {
      description:
        'Ontology Gas is a cryptocurrency which is distributed by holding ONT in your wallet. ONG is used to fuel transactions on the Ontology blockchain.',
      reddit: 'https://www.reddit.com/r/OntologyNetwork',
      twitter: 'https://twitter.com/OntologyNetwork',
      website: 'https://ont.io',
      telegram: 'https://t.me/OntologyNetwork',
    },
    primaryColor: '#7DD9F3',
    gradientColors: ['#7DD9F3', '#3A92CD'],
    gradientCoords: { x1: '11.224%', y1: '-66.682%', x2: '141.81%', y2: '91.487%' },
  },
]
